import { render, staticRenderFns } from "./8introduce.vue?vue&type=template&id=23f30558&scoped=true&"
import script from "./8introduce.vue?vue&type=script&lang=js&"
export * from "./8introduce.vue?vue&type=script&lang=js&"
import style0 from "./8introduce.vue?vue&type=style&index=0&id=23f30558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f30558",
  null
  
)

export default component.exports